module.exports = __webpack_public_path__ + "static/media/botones-05.f8a13d19.png";